import { isEmptyObject } from '@sky-it-livedata-libraries/livedata-commons';
import { TeamDriverPageQuery } from '../types';

/**
 * typeguard for TeamDriverPageQuery
 * @param TeamDriverPageQuery object passed to transformer
 */
export const isValidTeamDriverPage = (obj: TeamDriverPageQuery): boolean => Boolean(obj?.data?.getTeamDriverPageWidget && !isEmptyObject(obj.data.getTeamDriverPageWidget) );
